// extracted by mini-css-extract-plugin
export default {"wrapper":"Popper_wrapper__Y5iEg","action-wrapper":"Popper_action-wrapper__XqjDc"};